import { toast } from "@/components/ui/use-toast";
import { useExportPriceRemarkLabelAuditMutation } from "@/services/price-remark/monitoring";
import { LabelAuditExportFilter } from "@/services/price-remark/types";

import {
  EMAIL_PLACEHOLDER,
  PRICE_REMARK_EXPORT_MESSAGES,
} from "../../pending/constants";

export function useExportLabelAudit() {
  const [exportLabelAudit, { isLoading }] =
    useExportPriceRemarkLabelAuditMutation();

  const exportAll = async (filter: LabelAuditExportFilter) => {
    try {
      const queued = await exportLabelAudit(filter).unwrap();

      if (!queued?.jobId) {
        toast({
          description: PRICE_REMARK_EXPORT_MESSAGES.EMPTY_LABEL_AUDIT,
        });
        return;
      }

      toast({
        description: PRICE_REMARK_EXPORT_MESSAGES.QUEUED.replace(
          EMAIL_PLACEHOLDER,
          queued.email,
        ),
      });
    } catch {
      toast({
        description: PRICE_REMARK_EXPORT_MESSAGES.LABEL_AUDIT_ERROR,
        variant: "destructive",
      });
    }
  };

  return { exportAll, isExporting: isLoading };
}
